export default "__VITE_ASSET__e73f2915__"